/**
 * QC filter values for stage=label_separation worklists.
 * Must match backend qc_status filter strings (case-insensitive on server).
 */
import { QcStatusOption } from './types';

const LABEL_SEPARATION_QC_OPTIONS: QcStatusOption[] = [
  { label: 'Separation Pending', value: 'Separation Pending' },
  { label: 'Separated', value: 'Separated' }
];

export default LABEL_SEPARATION_QC_OPTIONS;
